export const ShareIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={22}
      height={22}
      viewBox='0 0 22 22'
      fill='none'
    >
      <g clipPath='url(#clip0_8_3772)'>
        <path
          d='M16.5 14.74C15.8033 14.74 15.18 15.015 14.7033 15.4458L8.1675 11.6416C8.21333 11.4308 8.25 11.22 8.25 11C8.25 10.78 8.21333 10.5691 8.1675 10.3583L14.63 6.59081C15.125 7.04915 15.7758 7.33331 16.5 7.33331C18.0217 7.33331 19.25 6.10498 19.25 4.58331C19.25 3.06165 18.0217 1.83331 16.5 1.83331C14.9783 1.83331 13.75 3.06165 13.75 4.58331C13.75 4.80331 13.7867 5.01415 13.8325 5.22498L7.37 8.99248C6.875 8.53415 6.22417 8.24998 5.5 8.24998C3.97833 8.24998 2.75 9.47831 2.75 11C2.75 12.5216 3.97833 13.75 5.5 13.75C6.22417 13.75 6.875 13.4658 7.37 13.0075L13.8967 16.8208C13.8508 17.0133 13.8233 17.215 13.8233 17.4166C13.8233 18.8925 15.0242 20.0933 16.5 20.0933C17.9758 20.0933 19.1767 18.8925 19.1767 17.4166C19.1767 15.9408 17.9758 14.74 16.5 14.74ZM16.5 3.66665C17.0042 3.66665 17.4167 4.07915 17.4167 4.58331C17.4167 5.08748 17.0042 5.49998 16.5 5.49998C15.9958 5.49998 15.5833 5.08748 15.5833 4.58331C15.5833 4.07915 15.9958 3.66665 16.5 3.66665ZM5.5 11.9166C4.99583 11.9166 4.58333 11.5041 4.58333 11C4.58333 10.4958 4.99583 10.0833 5.5 10.0833C6.00417 10.0833 6.41667 10.4958 6.41667 11C6.41667 11.5041 6.00417 11.9166 5.5 11.9166ZM16.5 18.3516C15.9958 18.3516 15.5833 17.9391 15.5833 17.435C15.5833 16.9308 15.9958 16.5183 16.5 16.5183C17.0042 16.5183 17.4167 16.9308 17.4167 17.435C17.4167 17.9391 17.0042 18.3516 16.5 18.3516Z'
          fill='#00C1D5'
        />
      </g>
      <defs>
        <clipPath id='clip0_8_3772'>
          <rect width={22} height={22} fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}
